import Grid from '@material-ui/core/Grid';
import SwitchWithLabel from '../../../DriverPopUp/common/CustomSwitch';
import { isReadOnlyPickupViewMode, isMergePickupMode, isCreateOrEditPickupMode } from '../utils';

const PickupTypeToggles = ({
  mode,
  pickupInfo,
  isAssignedPickup,
  toggleError,
  handlePickupTypeToggle,
  handleKeyDownPickTypeToggle,
  classes,
  isExhibitPickupInMergeMode,
  isReadOnlyPickupMergeMode
}) => {
  const isMergeFlow = isMergePickupMode(mode);
  const isCreateOrEditMode = isCreateOrEditPickupMode(mode);
  const isCreateEditMergeMode = isCreateOrEditMode || isMergeFlow;
  const isReadOnly = isReadOnlyPickupViewMode(mode) || isReadOnlyPickupMergeMode;

  return (
    <Grid container spacing={8} id="swapDropExhibit">
      <Grid item xs={4}>
        <SwitchWithLabel
          id="isSwapPickup"
          rowLabel="Is Pickup a Trailer Swap"
          onChange={handlePickupTypeToggle('isSwapPickup')}
          value={pickupInfo.isSwapPickup}
          disabled={isReadOnly}
          handleKeyDown={handleKeyDownPickTypeToggle}
          customClasses={classes}
        />
      </Grid>
      {isCreateEditMergeMode && (
        <Grid item xs={4}>
          <SwitchWithLabel
            id="isExhibitPickup"
            rowLabel="Is Exhibit Pickup"
            onChange={handlePickupTypeToggle(
              isMergeFlow ? 'isExhibitPickupInMergeMode' : 'isExhibitPickup'
            )}
            value={isMergeFlow ? isExhibitPickupInMergeMode : pickupInfo.isExhibitPickup}
            disabled={isReadOnly}
            handleKeyDown={handleKeyDownPickTypeToggle}
            customClasses={classes}
          />
        </Grid>
      )}
      {isCreateOrEditMode && !isAssignedPickup && (
        <Grid item xs={4}>
          <SwitchWithLabel
            id="isDockDropPickup"
            rowLabel="Is Pickup a Dock Drop"
            onChange={handlePickupTypeToggle('isDockDropPickup')}
            value={pickupInfo.isDockDropPickup}
            disabled={isReadOnly}
            handleKeyDown={handleKeyDownPickTypeToggle}
            customClasses={classes}
          />
        </Grid>
      )}
      {Boolean(toggleError) && <div className={classes.toggleErrorMessage}>{toggleError}</div>}
    </Grid>
  );
};

export default PickupTypeToggles;
